import {
  DEVTOOLS_TOKEN_COOKIE_NAME,
  DEVTOOLS_TOKEN_COOKIE_TTL_SECONDS,
} from './constants'

/**
 * Gets a cookie value by name
 */
const getCookieValue = (name: string): string | undefined => {
  if (typeof window === 'undefined') return undefined

  const cookies = document.cookie.split(';')
  const cookie = cookies.find((c) => c.trim().startsWith(`${name}=`))

  if (!cookie) return undefined

  const [, value] = cookie.trim().split('=')

  return value
}

/**
 * Check if DevTools is enabled by verifying if token cookie exists
 * Note: Full token validation happens server-side in handleDevToolsAuth
 */
export const isDebugPanelEnabled = (): boolean => {
  if (typeof window === 'undefined') return false

  const token = getCookieValue(DEVTOOLS_TOKEN_COOKIE_NAME)
  return !!token
}

/**
 * Set the DevTools token cookie (client-side)
 * @param token - The token to store
 */
export const setDevToolsToken = (token: string): void => {
  if (typeof window !== 'undefined') {
    document.cookie = `${DEVTOOLS_TOKEN_COOKIE_NAME}=${token}; path=/; max-age=${DEVTOOLS_TOKEN_COOKIE_TTL_SECONDS}; SameSite=Strict; Secure`
  }
}

/**
 * Get the DevTools token from cookie (client-side)
 * @returns The token value or undefined if not found
 */
export const getDevToolsToken = (): string | undefined => {
  return getCookieValue(DEVTOOLS_TOKEN_COOKIE_NAME)
}

/**
 * Remove the DevTools token cookie (client-side)
 */
export const removeDevToolsToken = (): void => {
  if (typeof window !== 'undefined') {
    document.cookie = `${DEVTOOLS_TOKEN_COOKIE_NAME}=; path=/; max-age=0`
  }
}
